import React from "react";
import { Entity } from "../models/registration/entity";

const EntityContext = React.createContext({
  entity: new Entity(),
  setEntity: (entity: Entity) => {}
});

export default EntityContext;